module.exports = __webpack_public_path__ + "media/images/ODC_HealthPower_and_Coin-52cdd587.png";